import React from "react";
import { DatePicker, theme, Tooltip } from 'antd';
import {
  PlusCircleOutlined,
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_TRUCK } from "../../constants/urls";
import { PATH } from "../../routes/CustomRoutes";
import { dateToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import dayjs from 'dayjs';
import _ from "lodash";

export default function DispenseChemicalTruckList() {
  const tableRef = React.useRef(null);
  const [rangeDate , setRangeDate] = React.useState({date_after : dayjs().format('YYYY-MM-DD'), date_before : dayjs().format('YYYY-MM-DD')});
  const [tableKey, setTableKey] = React.useState(0);
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 100,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.is_closed && <Tooltip triger='hover' title="จ่ายสารเคมี">
              <ColorButton 
                type='primary'
                override={colorSuccess}
                icon={<PlusCircleOutlined />}
                style={{ margin : 5}}
                onClick={()=> window.open(`${window.origin}${PATH.DISPENSE_CHEMICAL}/truck/${original.id}/`)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'วันที่',
      dataIndex: 'date',
      key: 'date',
      render : (value, original) => <center>{dateToHumanString(original.created)}</center>,
    },
    {
      title: 'ผู้ขายน้ำยางสด',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      searcher: true,
      render : (value, original) => <a onClick={() => window.open(`${window.origin}${PATH.DISPENSE_CHEMICAL}/seller/${original.supplier}/`)}>{value}</a>
    },
    {
      title: 'ทะเบียนรถ',
      dataIndex: 'vehicle_license_plate',
      key: 'vehicle_license_plate',
      searcher: true,
    },
    {
      title: 'การขายน้ำยางสด',
      children: [
        {
          title: 'น้ำยางสด (kg)',
          dataIndex: 'net_weight',
          key: 'net_weight',
          render: (value) => formatComma(toFixed(value, 0))
        },
        {
          title: 'NH3',
          dataIndex: '',
          key: 'lab_results_nh3',
          render: (value, original) => value.lab_results.find((e) => e.chemical === 'NH3') ? value.lab_results.find((e) => e.chemical === 'NH3').amount : '-'
        },
        {
          title: 'TZ',
          dataIndex: '',
          key: 'lab_results_tz',
          render: (value, original) => value.lab_results.find((e) => e.chemical === 'TZ') ? value.lab_results.find((e) => e.chemical === 'TZ').amount : '-'
        },
      ],
    },
    {
      title: 'การจ่ายสารเคมี',
      children: [
        {
          title: 'NH4OH',
          dataIndex: 'nh4oh_total_amount',
          key: 'nh4oh_total_amount',  
        },
        {
          title: 'TZ',
          dataIndex: 'tz_total_amount',
          key: 'tz_total_amount',
        },
      ],
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const resetFilterData = async() => {
    if(tableRef.current){
      resetFilters();
    }
  }

  const resetFilters = () => {
    setTableKey(tableKey => tableKey + 1);
  };

    React.useEffect(() => {
      resetFilterData();
    },[rangeDate])

    React.useEffect(() => {
      const interval = setInterval(() => {
        refreshData();
      }, 300000);

      return () => clearInterval(interval);
    }, []);

  return(
    <div>
      {/* <button onClick={() => resetFilters()}>resetFilter</button> */}
      วันที่ : 
      <DatePicker.RangePicker
        style={{ marginBottom : 10, marginLeft : 10, marginRight : 20 }}
        onCalendarChange={(dates, dateStrings) => setRangeDate({date_after : dateStrings[0], date_before : dateStrings[1]})}
        defaultValue={[dayjs(), dayjs()]}
      />
      <TSTable
        key={tableKey}
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TRUCK.TRUCK_TRANSACTION}
        params={{...rangeDate}}
      />
    </div>
  )
}